import { USER_LEVEL_KEY } from '~/api/interface';

export const PRODUCT_IMAGES = (key: USER_LEVEL_KEY) => {
  const prefix = !isGlobalVersion()
    ? getFeUrl('/youyan-platform/png/products/')
    : getFeUrl('/rendora/products/');

  const suffix: Record<USER_LEVEL_KEY, string> = {
    [USER_LEVEL_KEY.UN_AUTHORIZED]: '',
    [USER_LEVEL_KEY.TASTE]: 'personal-experience-edition.png',
    [USER_LEVEL_KEY.PERSONAL]: 'personal-edition.png',
    [USER_LEVEL_KEY.PERSONAL_LITE]: 'personal-lite-edition.png',
    [USER_LEVEL_KEY.TEAM_LIGHT]: 'team-lite-edition.png',
    [USER_LEVEL_KEY.TEAM_TASTE]: 'team-experience-edition.png',
    [USER_LEVEL_KEY.ORG_STANDARD]: 'enterprise-edition.png',
    [USER_LEVEL_KEY.ORG_FLAGSHIP]: 'enterprise-edition.png',
  };

  return suffix[key] ? prefix + suffix[key] : '';
};
